import { useGetAccountSettings, useGetUserProfile } from "@/tanstack-hooks";
import OnboardingFlow from "@/components/onboarding/OnboardingFlow";
import { UserProfile, UserStatus } from "@/generated-api";
import BannedStatus from "@/components/BannedStatus";
import { useAuthStore } from "@/stores/authStore";
import ExplorePage from "./ExplorePage";
import PulseLoader from "@/components/PulseLoader";
import AiMatchPage from "./AiMatchPage";
import { REVIEWER_EMAILS } from "@/lib/utils";

export default function Dashboard() {
  const getUserProfileQuery = useGetUserProfile();
  const accountSettingsQuery = useGetAccountSettings();
  const { clearToken } = useAuthStore();

  if (getUserProfileQuery.isLoading) {
    return (
      <div className="flex w-full items-center justify-center h-[93vh]">
        <PulseLoader />
      </div>
    );
  }

  if (getUserProfileQuery.error) {
    clearToken();
  }

  const userProfile = getUserProfileQuery.data as UserProfile;

  return (
    <>
      {userProfile.status === UserStatus.ONBOARDING ? (
        <div className="flex w-full items-center justify-center">
          <OnboardingFlow user={userProfile} />
        </div>
      ) : userProfile.status === UserStatus.ACTIVE ||
        userProfile.status === UserStatus.ACTIVE_HIDDEN ? (
        <>
          {REVIEWER_EMAILS.includes(accountSettingsQuery.data?.email ?? "") ? (
            <AiMatchPage />
          ) : (
            <ExplorePage />
          )}
        </>
      ) : (
        <div className="flex w-full items-center justify-center">
          <BannedStatus banReason={userProfile.ban_reason} />
        </div>
      )}
    </>
  );
}
